var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_316651242947539446071327883455581647577",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_68053481213083395807772091241353724213",
    d: "M2.06.325c1.105 0 2 .895 2 2v20c0 1.104-.895 2-2 2-1.104 0-2-.896-2-2v-20c0-1.105.896-2 2-2zm13.334 0c1.105 0 2 .895 2 2v20c0 1.104-.895 2-2 2s-2-.896-2-2v-20c0-1.105.895-2 2-2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164 -434) translate(148 426) translate(16 8) translate(7.94 3.675)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_176240733608817097881008305712412828067",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_68053481213083395807772091241353724213"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    d: "M2.06.825c.415 0 .79.168 1.061.44.272.27.44.646.44 1.06h0v20c0 .414-.168.789-.44 1.06-.271.272-.646.44-1.06.44-.415 0-.79-.168-1.061-.44-.272-.271-.44-.646-.44-1.06h0v-20c0-.414.168-.79.44-1.06.271-.272.646-.44 1.06-.44zm13.334 0c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06h0v20c0 .414-.168.789-.44 1.06-.27.272-.646.44-1.06.44-.414 0-.79-.168-1.06-.44-.272-.271-.44-.646-.44-1.06h0v-20c0-.414.168-.79.44-1.06.27-.272.646-.44 1.06-.44z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#hinava_random_uuid_316651242947539446071327883455581647577)",
    mask: "url(#hinava_random_uuid_176240733608817097881008305712412828067)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 549.545,
    height: 269.517,
    rx: 8,
    transform: "translate(-265.333 -154.333)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.de9428a91f44ff1fd20efa439eadfa8a.svg";
export { ForwardRef as ReactComponent };